<template>
  <Transition name="ptr-fade">
    <div
      v-if="isPulling || isRefreshing"
      class="ptr-indicator"
      :style="{ transform: `translateY(${translateY}px)` }"
    >
      <div class="ptr-indicator__pill">
        <svg
          class="ptr-indicator__icon"
          :class="{ 'ptr-indicator__icon--spinning': isRefreshing }"
          :style="!isRefreshing ? { transform: `rotate(${rotation}deg)`, opacity: opacity } : {}"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 12a9 9 0 1 1-2.636-6.364"
            stroke="#1CA55C"
            stroke-width="2.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePullToRefresh } from '@modules/app/composables/usePullToRefresh';

const { pullDistance, isPulling, isRefreshing } = usePullToRefresh();

const THRESHOLD = 70;

const translateY = computed(() => {
  if (isRefreshing.value) return 16;
  // Map pullDistance (0 → THRESHOLD+) to translateY (-40 → 16)
  const progress = Math.min(pullDistance.value / THRESHOLD, 1);
  return -40 + progress * 56;
});

const rotation = computed(() => {
  return (pullDistance.value / THRESHOLD) * 360;
});

const opacity = computed(() => {
  return Math.min(pullDistance.value / THRESHOLD, 1);
});
</script>

<style scoped>
.ptr-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.ptr-indicator__pill {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ptr-indicator__icon--spinning {
  animation: ptr-spin 0.8s linear infinite;
}

@keyframes ptr-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.ptr-fade-enter-active {
  transition: opacity 0.15s ease;
}
.ptr-fade-leave-active {
  transition: opacity 0.25s ease;
}
.ptr-fade-enter-from,
.ptr-fade-leave-to {
  opacity: 0;
}
</style>
